import { registerRoutingKey } from "Common/routingUtils";
import locale from "./routesMap.locale";
export default {
    USERS: registerRoutingKey("USERS"),
    CONNECTIONS: registerRoutingKey("CONNECTIONS"),
    ROLES: registerRoutingKey("ROLES"),
    ACTION_LOG: registerRoutingKey("ACTION_LOG"),
    TASK_STATISTICS: registerRoutingKey("TASK_STATISTICS"),
    METHODS: registerRoutingKey("METHODS"),
    PASSWORD_POLICY: registerRoutingKey("PASSWORD_POLICY"),
    BILLING: registerRoutingKey("BILLING")
};
const AREA_TITLE = locale.PANEL_ADMIN;
export { AREA_TITLE };
